import React from 'react';
import * as Form from 'react-hook-form';
import { Keyboard } from 'react-native';
import { t } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';

import SignUpPhone from '@src/api/SignUpPhone';
import { phoneNumberExtractor, phoneNumberRegex } from '@src/helpers';
import { i18n, i18yup } from '@src/i18n';

import { FormData } from './types';

const useForm = () => {
  const navigation = useNavigation();
  const [loading, setLoading] = React.useState(false);
  const form = Form.useForm<FormData>({
    validationSchema: i18yup.object<FormData>({
      phone: i18yup
        .string()
        .required()
        .matches(phoneNumberRegex, i18n._(t`Must contain only digits`))
        .label(i18n._(t`Phone`)),
      region: i18yup
        .string()
        .required()
        .label(i18n._(t`Region`)),
    }),
  });

  const handleSubmit = React.useCallback(
    async ({ phone, region }: FormData) => {
      try {
        Keyboard.dismiss();
        setLoading(true);

        const response = await SignUpPhone({ phone, region });
        navigation.navigate('SignUpOTP', {
          phone: phoneNumberExtractor(phone, region),
          region,
          preToken: response.data.preToken,
          ttl: response.data.ttl,
        });
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    },
    [navigation]
  );

  return React.useMemo(
    () => ({
      form,
      handleSubmit: form.handleSubmit(handleSubmit),
      loading,
    }),
    [form, handleSubmit, loading]
  );
};

export default useForm;
